<div class="ltr main-body leftmenu">
	<form autocomplete="off" novalidate [formGroup]="SuperExamForm">
		<div class="main-content side-content pt-0 ml-0">
			<div class="main-container container">
				<div class="inner-body">
					<div class="row row-sm add-form">
						<div class="col-lg-12 col-md-12">
							<div class="card custom-card">
								<div class="card-body">
									<div class="row">
										<div class="col">
											<div class=" d-flex align-items-center pl-3">
												<img alt="Logo" src="../../assets/img/ExamSubject.png"
													class="mh-45px pb-2">
												<div class="ml-2">
													<h3 class="main-content-label mb-1"><b>
															Supervisor For Exam
														</b></h3>
													<p class="text-muted card-sub-title mb-0">
														Select Users For Exam
													</p>
												</div>
											</div>
										</div>
									</div>
									<hr class="mt-1 mb-1">
									<div class="row">
										<div class="col-sm-10 p-0">
											<div class="row">
												<div class="col-sm-4">
													<div class="col-sm-12">
														<mat-radio-group class="example-full-width"
															aria-label="Select an option" formControlName="radio">
															<div class="row">
																<div class="col-sm-4 p-1 ml-1 mt-2">
																	<mat-radio-button class="ml-1" value="user"
																		(click)="userClick()">By User
																	</mat-radio-button>
																</div>
																<div class="col-sm-4 p-1 ml-1 mt-2">
																	<mat-radio-button class="ml-1" value="exam"
																		(click)="examClick()">By Exam
																	</mat-radio-button>
																</div>
															</div>
														</mat-radio-group>
													</div>
												</div>
												<div *ngIf="isShownUserDiv==true" class="col-sm-4">

													<mat-form-field appearance="outline" class="example-full-width">
														<mat-label> User Name</mat-label>
														<mat-select [disabled]=" isExamRadioBtn" #select23
															placeholder="LoginId" class="colorblack"
															formControlName="user">
															<mat-select-filter *ngIf="select23.focused"
																[placeholder]="'Filter'"
																[displayMember]="'LoginFullName'" [array]="userList"
																(filteredReturn)="filteredUserList =$event">
															</mat-select-filter>
															<mat-option *ngFor="let item of filteredUserList"
																[value]="item.LoginId"
																(click)="oneUserClick(item.LoginId,'')">{{item.LoginId}}
																- {{item.LoginFullName}}
															</mat-option>
														</mat-select>
													</mat-form-field>
												</div>
												<div *ngIf="isShownExamDiv==true" class="col-sm-4">

													<mat-form-field appearance="outline" class="example-full-width">
														<mat-label> Exam Name</mat-label>
														<mat-select [disabled]="isUserRadioBtn" #select22
															placeholder="EmId" class="colorblack"
															formControlName="exam">
															<mat-select-filter *ngIf="select22.focused"
																[placeholder]="'Filter'" [displayMember]="'EmName'"
																[array]="examList"
																(filteredReturn)="filteredExamList =$event">
															</mat-select-filter>
															<mat-option *ngFor="let item of filteredExamList"
																[value]="item.EmId"
																(click)="oneExamClick(item.EmId,'')">
                                                                {{ item | displayValue:'EmCode':'EmName' }}
															</mat-option>
														</mat-select>
													</mat-form-field>

												</div>
											</div>
										</div>
										<div class="col-sm-12">
											<div class="col-sm-12 prpl">

												<button *ngIf="submitexam && superCreate" id="addBtn" type="button"
													class="btn btn-primary btn-icon-text floatleft mt-1 fr"
													(click)="submit()">
													<span style="display: contents; align-items: center;">
														<img width="15vh" src="../../assets/img/save.gif"
															style="margin-right: 5px;">
														Save
													</span>
												</button>
												<button *ngIf="submituser && superCreate" id="addBtn" type="button"
													class="btn btn-primary btn-icon-text floatright mt-1 fr"
													(click)="submit1()">
													<span style="display: contents; align-items: center;">
														<img width="15vh" src="../../assets/img/save.gif"
															style="margin-right: 5px;">
														Save
													</span>
												</button>
												<button *ngIf="reset" id="addBtn" type="button"
													class="btn btn-primary btn-icon-text floatright mr-3 mt-1 fr"
													(click)="back()">
													<span style="display: contents; align-items: center;">
														<img width="15vh" src="../../assets/img/turn-left.gif"
															style="margin-right: 7px;">
														Back
													</span>
												</button>
												<button type="button" *ngIf="reset" (click)="print()" class="btn btn-primary btn-icon-text floatright mr-3 mt-1">
													<span style="display: contents; align-items: center;">
														<img width="15vh" src="../../assets/img/printer.gif" style="margin-right: 7px;">
														Print
													</span>
												</button>
											</div>
										</div>
										<!-- <div class="col-sm-9"></div>
										<div class="col-sm-2 pri-0">
											<div class="row">
												<div class="col-sm-5"></div>
												<div class="col-sm-7">
													<button type="button" *ngIf="reset"
														class="btn btn-primary btn-icon-text floatright mt-1"
														(click)="back()">
														<span style="display: contents; align-items: center;">
															<img width="25%" src="../../assets/img/refresh.gif">
															Reset
														</span>
													</button>
												</div>
											</div>
										</div>
										<div class="col-sm-1 pri-0" *ngIf="submitexam && superCreate">
											<button type="button" class="btn btn-primary btn-icon-text floatright mt-1"
												(click)="submit()">
												<span style="display: contents; align-items: center;">
													<img width="25%" src="../../assets/img/save.gif">
													Save
												</span>
											</button>
										</div>
										<div class="col-sm-1 pri-0" *ngIf="submituser && superCreate">
											<button type="button" class="btn btn-primary btn-icon-text floatright mt-1"
												(click)="submit1()">
												<span style="display: contents; align-items: center;">
													<img width="25%" class="p-0" src="../../assets/img/save.gif">
													Save
												</span>
											</button>
										</div> -->
									</div>
									<hr class="mt-2 mb-2">
									<div class="row " *ngIf="isShownUserList==true">
										<div class="col-sm-8 ">
											<div class="bc d-flex align-items-center pl-3 mb-2">
												<img alt="Logo" src="../../assets/img/users.png" class="mh-40px pb-2">
												<div class="ml-2">
													<h3 class="main-content-label mb-1"><b>
															User
														</b></h3>
													<p class="text-muted card-sub-title mb-0">
														List Of User's
													</p>
												</div>
											</div>

										</div>
										<div class="col-sm-4 ">
											<mat-form-field appearance="outline" class="example-full-width">
												<mat-label>Search
												</mat-label> <input type="text" class="color" matInput
													placeholder="Search" (input)="applyFilter($event)">
												<mat-icon matSuffix>search</mat-icon>
											</mat-form-field>
										</div>
										<div class="table-responsive table-container">
											<table appShortTable id="datatable" class="table table-bordered text-nowrap text-left">
												<thead>
													<tr>
														<th class="f600 text-center" width="5%"> Action
														</th>
														<th class="f600 " width="90%"> User Name </th>
													</tr>
												</thead>
												<tbody id="table_data" formArrayName="UserArr">
													<tr *ngFor="let user of getControls(); let i = index"
														[formGroupName]="i">
														<td class="text-center">
															<mat-checkbox formControlName="clgexamcheckbox"
																id="{{user.value.CoCgCgCode}}">
															</mat-checkbox>
														</td>
														<td> {{user.value.CoCgCgCode}} </td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
									<div class="row" *ngIf="isShownExamList==true">
										<div class="col-sm-8">
											<div class="bc d-flex align-items-center pl-3 mb-2">
												<img alt="Logo" src="../../assets/img/ExamMaster.png"
													class="mh-40px pb-2">
												<div class="ml-2">
													<h3 class="main-content-label mb-1"><b>
															Exam
														</b></h3>
													<p class="text-muted card-sub-title mb-0">
														List Of Exam's
													</p>
												</div>
											</div>

										</div>
										<div class="col-sm-4 ">
											<mat-form-field appearance="outline" class="example-full-width">
												<mat-label>Search
												</mat-label> <input type="text" class="color" matInput
													placeholder="Search" (input)="applyFilter($event)">
												<mat-icon matSuffix>search</mat-icon>
											</mat-form-field>
										</div>
										<div class="table-responsive table-container" formArrayName="ExamArr">
											<table appShortTable id="datatable" class="table  table-bordered text-nowrap text-left">
												<thead>
													<tr>
														<th class="f600 text-center" width="5%"> Action
														</th>
														<th class="f600 text-left" width="90%"> Exam Name </th>
													</tr>
												</thead>
												<tbody id="table_data">
													<tr *ngFor="let exam of getControls1(); let i = index"
														[formGroupName]="i">
														<td class="text-center">
															<mat-checkbox formControlName="clgexamcheckbox"
																id="{{exam.value.CoCgCoCode}}">
															</mat-checkbox>
														</td>
														<td class="text-left"> {{exam.value.CoCgCoCode}} </td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</form>
</div>